import React from 'react';

import config from 'config';

import { purple } from '../../utils/color-styles';

interface TermsOfServiceProps {
  isSso?: boolean;
}

const TermsOfService = ({ isSso = false }: TermsOfServiceProps): JSX.Element | null => {
  const { clientUrl } = config;

  const tosLink = `${clientUrl}/terms`;
  const privacyLink = `${clientUrl}/privacy`;

  const styles: Partial<{ [key: string]: React.CSSProperties }> = {
    container: {
      display: 'block',
      fontSize: '11px',
    },
    link: {
      color: purple,
      cursor: 'pointer',
      textDecoration: 'none',
      WebkitTextDecorationSkip: 'none',
    },
  };

  // @NOTE-EV: TODO - update terms of service when it's SSO login
  return (
    <>
      <span style={{ ...styles.container }}>
        {isSso ? 'By logging in through SSO' : 'By signing up'} you agree to the{' '}
        <a style={{ ...styles.link }} href={tosLink} target="_blank">
          Terms of Use
        </a>{' '}
        and consent to the processing of your personal data according to the{' '}
        <a style={{ ...styles.link }} href={privacyLink} target="_blank">
          Privacy Policy
        </a>
        .
      </span>
    </>
  );
};

export default TermsOfService;
